export var Stages;

(function (Stages) {
  Stages["DEV"] = "dev";
  Stages["STAGING"] = "staging";
  Stages["PRODUCTION"] = "production";
  Stages["PRODUCTION_LEGACY"] = "productionLegacy";
})(Stages || (Stages = {}));